
// External config
export const COMPANY_SHARES_FIELD = process.env.COMPANY_SHARES_FIELD;
export const COMPANY_LINK = process.env.COMPANY_LINK;
export const SHAREHOLDER_LINK = process.env.SHAREHOLDER_LINK;
export const SHARES_PP_FIELD = process.env.SHARES_PP_FIELD;
export const SHARES_UF_FIELD = process.env.SHARES_UF_FIELD;
export const SHARES_NP_FIELD = process.env.SHARES_NP_FIELD;
export const SHARES_AT_FIELD = process.env.SHARES_AT_FIELD;

export const TYPE_SOCIETE_FIELD = process.env.TYPE_SOCIETE_FIELD;
export const TYPE_SOCIETE_MAP = JSON.parse(process.env.TYPE_SOCIETE_MAP);


// Design config
export const SVG_NS = 'http://www.w3.org/2000/svg';
export const GRID_CELL_HEIGHT = 24;
export const GRID_CELL_WIDTH = GRID_CELL_HEIGHT * 4;
export const GRID_SEGMENT_HEIGHT = GRID_CELL_HEIGHT * 10;
export const GRID_SEGMENT_WIDTH = GRID_CELL_WIDTH * 4;

export const MIN_ZOOM = 0.5;
export const MAX_ZOOM = 2;
export const ZOOM_STEP = 0.05;


export const NODE_FONT_FAMILY = 'Times New Roman';
export const NODE_FONT_SIZE = '16px';
export const NODE_DEFAULT_HEIGHT = GRID_CELL_HEIGHT * 2;
export const NODE_DEFAULT_WIDTH = GRID_CELL_WIDTH * 2;
export const NODE_X_PADDING = 16;
export const NODE_RADIUS = 4;

export const LINK_FONT_SIZE = 10;
export const LINK_FONT_SIZE_PX = LINK_FONT_SIZE + 'px';

export const NODE_LAYOUT_GAP_X = GRID_CELL_WIDTH * 2;
export const NODE_LAYOUT_GAP_Y = GRID_CELL_HEIGHT * 4;


export function snapToGridX(n: number) {
  
  if(Math.abs(n % GRID_CELL_WIDTH) > 0) {
    n = Math.round(n / GRID_CELL_WIDTH) * GRID_CELL_WIDTH;
  }

  return n;
}

export function snapToGridY(n: number) {
  
  if(Math.abs(n % GRID_CELL_HEIGHT) > 0) {
    n = Math.round(n / GRID_CELL_HEIGHT) * GRID_CELL_HEIGHT;
  }

  return n;
}

export function forceInsideRange(n: number, min: number, max: number) {
  if(n > max) {
    return max;
  }
  else if(n < min) {
    return min;
  }
  else {
    return n;
  }
}